import _ from 'lodash';
import moment from 'moment';

const defaultTimezone = moment.tz.guess();

export function lowerCase(text) {
  return text.toLowerCase();
}

export function upperCase(text) {
  return text.toUpperCase();
}

export function removeDash(text) {
  return text.replaceAll(['_'], '');
}

export function replaceDash(text) {
  return text.replaceAll(['_'], ' ');
}

export function convertMeterToMileString(val) {
  if (!val || isNaN(val)) return '';

  return `${convertMeterToMile(+val, 1)}`;
}

export function convertSecondToHour(val) {
  if (!val || isNaN(val)) return '';

  return secondToHour(+val);
}

export function capitalizeText(val) {
  if (!val) return '';

  return val.replace(/(^\w|\s\w)(\S*)/g, (_, m1, m2) => m1.toUpperCase() + m2.toLowerCase());
}

export function splitText(val, options) {
  if (!val) return '';
  const symbol = _.isEmpty(options?.hash && options.hash.symbol) ? ',' : options.hash.symbol;
  const valSplit = val.split(symbol);
  return !Array.isArray(valSplit) ? [] : valSplit.map((item) => item.trim());
}

export function formatDateTime(date, timezone, format) {
  const tz = timezone || defaultTimezone;

  if (!date) return '';

  return `${moment.tz(date, tz).format(format || `MM/DD/YYYY HH:mm z`)}`;
}

// no-dd-sa:javascript-code-style/parameter-name
export function when(operand_1, operator, operand_2, options) {
  operator = operator || 'eq';

  const operators = {
    eq: (l, r) => {
      // no-dd-sa:javascript-code-style/strict-equals
      return l == r;
    },
    ne: (l, r) => {
      // no-dd-sa:javascript-code-style/strict-equals
      return l != r;
    },
    gt: (l, r) => {
      return Number(l) > Number(r);
    },
    gte: (l, r) => {
      return Number(l) >= Number(r);
    },
    lt: (l, r) => {
      return Number(l) < Number(r);
    },
    lte: (l, r) => {
      return Number(l) <= Number(r);
    },
  };

  const result = operators[operator](operand_1, operand_2);

  if (result) return options.fn(this);
  else return options.inverse(this);
}

export function whenAnd(opts) {
  let isTrue = true;
  Object.keys(opts.hash).forEach((k) => {
    if (_.get(opts.data.root, k) !== opts.hash[k]) {
      isTrue = false;
    }
  });

  if (isTrue) return opts.fn(this);
  else return opts.inverse(this);
}

export function whenOr(opts) {
  let isTrue = false;
  Object.keys(opts.hash).forEach((k) => {
    if (_.get(opts.data.root, k) === opts.hash[k]) {
      isTrue = true;
    }
  });

  if (isTrue) return opts.fn(this);
  else return opts.inverse(this);
}

const secondToHour = (minute) => {
  if (!minute) return '';
  const duration = moment.duration(minute, 'seconds');

  //calculate hours
  const hh = duration.years() * (365 * 24) + duration.months() * (30 * 24) + duration.days() * 24 + duration.hours();

  //get minutes
  const mm = duration.minutes();
  if (hh === 0) return mm + 'mins';
  //return total time in HH:mm format
  return hh + 'hrs ' + mm + 'mins';
};

const MILE_TO_METER = 1609.34;
const convertMeterToMile = (val, decimal_number = 1) => {
  return (val / MILE_TO_METER).toFixed(decimal_number);
};

export function stringReplace(str, searchValue, newValue) {
  return str.replace(searchValue, newValue);
}
